import { CompositeResponseError } from '@/shared/api/validation'

export function shouldShowCancelInvoiceWarningModal(err: unknown) {
  // Not a composite response error.
  if (!(err instanceof CompositeResponseError)) {
    return false
  }

  // Show if there's a mention of a revocation failure
  return err.failures.some(x => x.operation === 'revoke_credit_note_allocation')
}
